module.exports = __webpack_public_path__ + "static/media/logo-black.47469250.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-black.svg
// module id = 352
// module chunks = 0